var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content voucher-maintenance" }, [
    _c("div", { staticClass: "tabs-container" }, [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageMode === 0,
                expression: "pageMode === 0"
              }
            ],
            staticClass: "main-content voucher-list"
          },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": "1700",
                  reset: true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "SystemMaintenance.QuickSearchAdNumber"
                  ),
                  "auto-init": _vm.searchItemAutoInit,
                  "custom-search-items": _vm.customSearchItems
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "triggers",
                    attrs: { slot: "operations" },
                    slot: "operations"
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.toNew } },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.toDelete }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                    ),
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.toView } },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.toOffShelf }
                      },
                      [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Remove")))]
                    ),
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.toPush } },
                      [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Publish")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: _vm.onReady
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "page-count": _vm.filter.pageCount,
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQueryByPage
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageMode === 1,
                expression: "pageMode === 1"
              }
            ],
            staticClass: "main-content voucher-list"
          },
          [
            _c("ad-details", {
              ref: "detail",
              on: {
                back: _vm.back,
                toPush: _vm.doPush,
                refresh: _vm.refreshList
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }